import type { FC } from 'react'

import styles from './PageDivider.module.scss'

const PageDivider: FC = () => <hr className={styles.pageDivider} />

export default PageDivider
